/**
 * Routes that don't require authorization of any kind
 * When the user visits this routes, we shouldn't redirect to login
 * if any non public operation fails
 */
export const PUBLIC_ROUTES = ['/login', '/home', '/whoweare', '/argenfrut', '/contact'];
